import { Injectable        } from '@angular/core';
import { NotifierManager   } from '../managers/notifier/notifier.manager';
import { Notifier          } from '../enums/notifier/notifier.enum';
import { NotifierMessage   } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})

export class PasswordChangeError 
{
    constructor(private _notifier : NotifierManager) {}

    generic () 
    {
      this._notifier.show(Notifier.ERROR, NotifierMessage.PASSWORD_CHANGE_GENERIC)
    }

    samePassword()
    {
      this._notifier.show(Notifier.ERROR, NotifierMessage.PASSWORD_CHANGE_SAME_PASSWORD)
    }

    wrongPassword()
    {
      this._notifier.show(Notifier.ERROR, NotifierMessage.PASSWORD_CHANGE_WRONG_PASSWORD)
    }
}